import React, { useState } from 'react';
import Section from './Section';
import { COURSES } from '../data/courses';

export default function Courses() {
  const [open, setOpen] = useState(null);
  return (
    <Section id="school" num="05" title="Coursework" subtitle="Relevant courses at Whitman College">
      <div className="courses reveal">
        {COURSES.map((c, i) => (
          <div className={`course${open === i ? ' course--open' : ''}`} key={c.name}>
            <button className="course__toggle" aria-expanded={open === i} onClick={() => setOpen(open === i ? null : i)}>
              <span><span className="course__code">{c.code}</span>{c.name}</span>
              <span className="course__arrow">▼</span>
            </button>
            <div className="course__body">
              <div className="course__body-inner">
                <div className="course__content">
                  <div className="tags">{c.tech.map((t) => <span className="tag" key={t}>{t}</span>)}</div>
                  <ul className="bullets">{c.bullets.map((b, j) => <li key={j}>{b}</li>)}</ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
